import { createIcon } from "@chakra-ui/react";

const RepeatIcon = createIcon({
  displayName: "RepeatIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        d="M8.46875 9.46973L9.52941 10.5304L13.0597 7.00006L9.52941 3.46973L8.46875 4.53039L9.93878 6.00042C6.65327 6.03326 4 8.70684 4 12.0001C4 14.6126 5.66962 16.835 8 17.6587V16.0324C6.51828 15.296 5.5 13.767 5.5 12.0001C5.5 9.51483 7.51472 7.50011 10 7.50011H10.4384L8.46875 9.46973Z"
        fill="currentColor"
      />
      <path
        d="M16 7.96787C17.4817 8.70422 18.5 10.2333 18.5 12.0001C18.5 14.4854 16.4853 16.5001 14 16.5001H13.5616L15.5312 14.5305L14.4706 13.4698L10.9403 17.0002L14.4706 20.5305L15.5312 19.4698L14.0612 17.9998C17.3467 17.967 20 15.2934 20 12.0001C20 9.38768 18.3304 7.1652 16 6.34153V7.96787Z"
        fill="currentColor"
      />
    </>
  ),
});

export default RepeatIcon;
